import { combineReducers } from 'redux';

import checkboxGroups from './checkboxGroups';
import signatureFields from './signatureFields';
import textFields from './textFields';

const idsReducer = combineReducers({
  checkboxGroups,
  signatureFields,
  textFields,
});

export default idsReducer;
